import { type ExportJobDto } from "definitions/exporter";
import { useLocation } from "react-router-dom";
import { appConfig } from "src/config/default";
import { formatDate } from "src/util";

export const useJobMetadata = (job: ExportJobDto | null) => {
  const location = useLocation();

  const url = `https://${appConfig.domain}${location.pathname}`;
  const counter = job?.data?.counter;
  const isUnlimited = !counter?.total;

  // S3-presigned logFileLink (~1000+ chars) пушил весь t.me prefill через 414
  // на прокси саппорта — он и так доступен отдельной кнопкой «Скачать логи»
  // рядом. В саппорт-сообщение достаточно task ID и ссылки на страницу.
  const metadata = [
    `Задача: ${job?.id ?? "Unknown"}`,
    `Ссылка: ${url}`,
    `Пользователь: ${job?.data?.userId ?? "Unknown"}`,
    `Тариф:
        ИД: ${counter?.id}
        Тип: ${job?.data?.platform}
        Запросы: ${isUnlimited ? "Безлимит" : `${counter?.spent ?? 0}/${counter?.total ?? 0}`}
        Время окончания: ${formatDate(counter?.expireAt ?? 0)}`,
  ];

  return metadata.join("\n");
};
